import _ from "lodash";
import PropTypes from "prop-types";
import React, { useContext } from "react";
import { createUseStyles } from "react-jss";
import { StyleTypeContext, TranslationContext } from "../../../umbilical_tools";
import jssVariables from "../../../jss_setup";
import Features from "./Features";
import SafetyInfo from "./SafetyInfo";

const infoStyles = createUseStyles({
  Info: (props) => ({
    margin: jssVariables.spacing.section_margin_mobile_small,
    ..._.get(props, "customStyles.Info", {}),
  }),
  infoContr: (props) => ({
    display: "grid",
    gridGap: props.showBullet ? jssVariables.normal_gap : 0,
    gridAutoRows: "max-content",
    padding: jssVariables.spacing.center_padding_mobile_medium,
    ..._.get(props, "customStyles.infoContr", {}),
  }),
  title: (props) => ({
    fontSize: "x-large",
    fontWeight: "bold",
    textTransform: "capitalize",
    ..._.get(props, "customStyles.title", {}),
  }),
  list: (props) => ({
    padding: [jssVariables.half_gap, 0],
    display: "grid",
    gridGap: jssVariables.normal_gap,
    maxHeight: "40vh",
    overflow: "auto",
    ..._.get(props, "customStyles.list", {}),
  }),
  description: (props) => ({
    display: "grid",
    gridTemplateColumns: "max-content 1fr",
    gridGap: props.showBullet ? jssVariables.normal_gap : 0,
    alignItems: "baseline",
    fontWeight: "normal",
    fontSize: "medium",
    ..._.get(props, "customStyles.infoDescription", {}),
  }),
  text: (props) => ({
    fontSize: "medium",
    ..._.get(props, "customStyles.text", {}),
  }),
  icon: (props) => ({
    background: jssVariables.colors.base_color,
    width: jssVariables.normal_gap,
    height: jssVariables.normal_gap,
    borderRadius: "50%",
    ..._.get(props, "customStyles.icon", {}),
  }),
  [`@media ${jssVariables.media.smallscreen}`]: {
    infoContr: (props) => ({
      padding: "0 25vw 0 15vw",
      paddingTop: jssVariables.double_gap,
      ..._.get(props, "customStyles.infoContr.smallscreen", {}),
    }),
    list: (props) => ({
      maxHeight: "30vh",
      ..._.get(props, "customStyles.list.smallscreen", {}),
    }),
    description: (props) => ({
      fontSize: "large",
      ..._.get(props, "customStyles.description.smallscreen", {}),
    }),
    text: (props) => ({
      fontSize: "large",
      ..._.get(props, "customStyles.text.smallscreen", {}),
    }),
  },
  [`@media ${jssVariables.media.bigscreen}`]: {
    infoContr: (props) => ({
      padding: jssVariables.spacing.center_padding_large,
      paddingTop: jssVariables.double_gap,
      ..._.get(props, "customStyles.infoContr.bigscreen", {}),
    }),
  },
});
const Info = ({ fieldName, data, showBullet }) => {
  const { type, brand, cStyler } = useContext(StyleTypeContext);
  const { t } = useContext(TranslationContext);

  const classes = infoStyles({
    customStyles: cStyler({ type, brand, objName: "actInfoStyles" }),
    showBullet,
  });

  return (
    <div className={classes.Info}>
      <div className={classes.infoContr}>
        <div className={classes.title}>{t(`${fieldName}`)}</div>

        {fieldName === "features" ? (
          <Features activity={data} />
        ) : fieldName === "safetyInfo" ? (
          <SafetyInfo data={data} />
        ) : (
          <div className={classes.list}>
            {data.map((d, idx) => (
              <h6 key={idx} className={classes.description}>
                {showBullet ? <div className={classes.icon} /> : <div />}
                {_.isArray(d) ? (
                  <span className={classes.text}>
                    <strong>{t(d[0])}</strong>: {d[1]}
                  </span>
                ) : (
                  d
                )}
              </h6>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};
Info.defaultProps = {
  fieldName: "",
  data: [],
  showBullet: true,
};
Info.propTypes = {
  fieldName: PropTypes.string.isRequired,
  data: PropTypes.array.isRequired,
  showBullet: PropTypes.bool,
};
export default Info;
